import isEqual from 'utils/common/isEqual';
import { formatPhaseAssignments } from 'utils/common/loadBalancingHelpers';

import { useAppSelector } from 'redux-store';
import type {
  ChargerFullStatusReading,
  LoadBalancingTotalAmpere,
} from 'redux-store/slices/api/types';

interface DeviceInfoProps {
  data: {
    loadBalancingGroupId: string;
    loadBalancingData?: LoadBalancingTotalAmpere;
    loadBalancingPriority?: number;
    loadBalancingFallbackCurrent?: number;
    loadMapping?: string;
    serials: string[];
  };
}

const useGetLoadBalancingGroup = (serials: string[]): DeviceInfoProps[] => {
  return useAppSelector(state => {
    if (!serials.length) return [];

    const groups = new Map<
      string,
      {
        loadBalancingData?: LoadBalancingTotalAmpere;
        loadBalancingPriority?: number;
        loadBalancingFallbackCurrent?: number;
        loadMapping?: string;
        serials: string[];
      }
    >();

    serials.forEach(serial => {
      const status = state.api.fullStatus[serial] as
        | ChargerFullStatusReading
        | undefined;
      const loadBalancingGroupId = status?.log;

      if (!loadBalancingGroupId) return;

      let existingGroup = groups.get(loadBalancingGroupId);

      if (!existingGroup) {
        existingGroup = {
          loadBalancingData: status.lot,
          loadBalancingPriority: status.lop,
          loadBalancingFallbackCurrent: status.lof,
          loadMapping: formatPhaseAssignments(status.map),
          serials: [],
        };
        groups.set(loadBalancingGroupId, existingGroup);
      }

      existingGroup.serials.push(serial);
    });

    return Array.from(groups.entries()).map(
      ([loadBalancingGroupId, group]) => ({
        data: {
          loadBalancingGroupId,
          ...group,
        },
      }),
    );
  }, isEqual); // The isEqual prevents unnecessary WebSocket updates from re-rendering
};

export default useGetLoadBalancingGroup;
